export default {"src":"/_next/static/media/numbers.3dd4b09b.svg","height":48,"width":48};